<script>

import {mapActions} from "vuex";
import ChooseRecycleDisposalPatternBotton from "@/driver/components/ChooseRecycleDisposalPatternBotton.vue";

export default {
  name: "RecycleFinalDisposalBasicInformation",
  components: {
    ChooseRecycleDisposalPatternBotton,
  },
  props: {
    /**
     * マニフェスト
     */
    manifest: {
      type: Object,
      default: () => ({}),
    },
    isFirstField: {
      type: Boolean,
      default: () => false,
    },
    copyTargetPattern: {
      type: Object,
      default: () => ({}),
    },
    /**
     *
     * single: 単体登録画面から呼び出されたかどうか
     * bulk: 一括登録画面から呼び出されたかどうか
     */
    callerType: {
      type: String,
      default: () => null,
    },
  },
  data() {
    return {
      standardQuantityTypes: [
        { value: 'fixed_quantity', text: '確定数量' },
        { value: 'waste_quantity', text: '廃棄物の数量' },
        { value: 'transport_quantity', text: '運搬業者の数量' },
        { value: 'disposal_quantity', text: '処分数量' },
      ],
      customMessages: {
        double: '数量は半角数字のみ使用できます'
      },
      patterns: null,
      originalQuantity: null,
    }
  },
  computed: {
    isBulk () {
      return this.callerType === 'bulk'
    },
    patternFixedCondition () {
      return {
        disposer_id: this.manifest.disposer_id,
        disposer_location_id: this.manifest.disposer_location_id,
        disposer_location_code: this.manifest.disposer_location_code,
        item_id: this.manifest.item_id,
        method_detail_ids: this.manifest.first_level_method_detail_ids,
        without_invisible: true,
        own_disposer: true
      };
    },
  },
  watch: {
    copyTargetPattern: {
      handler (newValue) {
        if (newValue) {
          const pattern = this.patterns.find( v => v.id === newValue.id && v.type === newValue.type )
          if (pattern) {
            this.manifest.pattern = pattern;
            this.manifest.pattern_id = pattern.value;
          }
        }
      },
    },
  },
  mounted() {
    this.reloadPatterns();
    this.originalQuantity = this.manifest.final_disposal_quantity
  },
  created() {
  },
  methods: {

    /**
     * 処理工程選択 再資源化等パターン
     */
    ...mapActions("DriverMasterSearchRecycleDisposalPattern", {
      fetchPatterns: "index",
      fetchPattern: "show"
    }),

    /**
     * 複写ボタン クリックイベント
     */
    copyFieldButtonClickEvent (property, value) {
      this.$emit("copy:field", property, value, this.manifest.pattern);
    },

    /**
     * 再資源化等パターン チェンジイベント
     */
    patternChangeEvent () {
      this.manifest.pattern = this.patterns.find(v => v.value === this.manifest.pattern_id);
    },

    /**
     * 再資源化等パターン 選択ボタンコールバック
     * リストでAを選択後、後工程を削除し選択で同じAを選んだ場合に変更なしと判断されリストの洗い替えが行われない問題があり
     * クリア後に時間を置いて反映し、洗い替えが行われるように対応
     */
    onPatternSelected (payload) {
      const selected = payload.pattern;
      const pattern = this.patterns.find(v => v.id === selected.id && v.type === selected.type);

      this.manifest.pattern = null;

      setTimeout(() => {
        this.manifest.pattern = pattern;
        if (pattern) {
          this.manifest.pattern_id = pattern.value;
          this.manifest.pattern = pattern;
        } else {
          this.manifest.pattern_id = selected.id;
          this.manifest.pattern = selected;
        }
      }, 100)

    },

    /**
     * 再資源化等パターンリストの再読込
     */
    reloadPatterns () {
      const condition = {
        disposer_id: this.manifest.disposer_id,
        disposer_location_code: this.manifest.disposer_location_code,
        method_detail_ids: this.manifest.first_level_method_detail_ids,
        item_ids: this.manifest.item_id,
        type: "flows",
        without_invisible: true,
      }
      this.fetchPatterns({ ...condition }).then(content => {
        this.patterns = content.recycle_disposal_patterns;
      })
    },

    /**
     * 基準重量変更イベント.
     */
    onStandardQuantityChange () {
      const selectedType = this.manifest.final_disposal_standard_quantity_type;
      let convertedKey = null
      if (selectedType === 'fixed_quantity') {
        convertedKey = 'conversion_fixed_quantity'
      } else if (selectedType === 'waste_quantity') {
        convertedKey = 'conversion_waste_quantity'
      } else if (selectedType === 'transport_quantity') {
        convertedKey = 'conversion_transport_quantity'
      } else if (selectedType === 'disposal_quantity') {
        convertedKey = 'conversion_disposal_quantity'
      }
      this.$set(this.manifest, 'final_disposal_quantity',  this.manifest?.[convertedKey])
    },

  },
}
</script>

<template>
  <div class="reportLayer">

    <h4 class="pb-3">再資源化等情報</h4>

    <!--基準重量, 重量 -->
    <v-row dense >

      <!-- 基準重量 -->
      <v-col cols="7">
        <div class="field-with-copy">
          <validation-provider
            v-slot="{ errors }"
            :vid="`final_disposal_standard_quantity_type-${manifest.id}`"
            class="requiredMark field-with-copy__control"
            name="基準重量"
            rules="required"
          >
            <v-select
              v-model="manifest.final_disposal_standard_quantity_type"
              :disabled="!manifest.target_for_registration"
              :error-messages="errors"
              :items="standardQuantityTypes"
              clearable
              dense
              hide-details="auto"
              label="基準重量"
              outlined
              persistent-placeholder
              @change="onStandardQuantityChange"
            />
          </validation-provider>
          <div
            v-if="!isBulk && isFirstField"
            class="copy-actions mt-1"
          >
            <v-btn
              :disabled="!manifest.target_for_registration"
              color="primary"
              small
              @mousedown.stop.prevent
              @click.stop="copyFieldButtonClickEvent('final_disposal_standard_quantity_type', manifest.final_disposal_standard_quantity_type)"
            >
              <v-icon>mdi-chevron-double-down</v-icon>
            </v-btn>
          </div>
        </div>
      </v-col>
      <!-- /基準重量 -->

      <!-- 重量 -->
      <v-col
        v-if="!isBulk"
        cols="5"
      >
        <div class="field-with-copy">
          <validation-provider
            v-slot="{ errors }"
            :custom-messages="customMessages"
            :disabled="!manifest.target_for_registration"
            rules="required|double|min_value:0.001|max_value:9999999999.999|quantityWithDecimal:10,3"
            :vid="`final_disposal_quantity-${manifest.id}`"
            class="requiredMark field-with-copy__control"
            name="重量"
          >
            <v-text-field
              v-model="manifest.final_disposal_quantity"
              :disabled="!manifest.target_for_registration"
              :error-messages="errors"
              dense
              hide-details="auto"
              label="重量"
              outlined
              persistent-placeholder
              type="number"
              reverse
              @keydown.69.prevent
            >
              <template v-slot:prepend-inner>
                <span class="mt-1">kg</span>
              </template>
            </v-text-field>
          </validation-provider>
          <div
            v-if="!isBulk && isFirstField"
            class="copy-actions mt-1"
          >
            <v-btn
              :disabled="!manifest.target_for_registration"
              color="primary"
              small
              @mousedown.stop.prevent
              @click.stop="copyFieldButtonClickEvent('final_disposal_quantity', manifest.final_disposal_quantity)"
            >
              <v-icon>mdi-chevron-double-down</v-icon>
            </v-btn>
          </div>
        </div>
      </v-col>
      <!-- /重量 -->

    </v-row>
    <!-- /基準重量, 重量 -->

    <!-- 処分事業場 -->
    <v-row dense>
      <v-col cols="12">
        処分事業場：{{ manifest.disposer_location_name || '-' }} /処分場処理方法：{{ manifest.recycle_disposer_disposal_method_name || '-' }}
      </v-col>
    </v-row>
    <!-- /処分事業場 -->

    <!-- 再資源化等パターン -->
    <v-row dense>
      <v-col cols="12">
        <p v-if="callerType === 'bulk' && patterns && patterns.length <= 0" class="red--text font-weight-bold">選択できる処理フローがありません。</p>
        <div class="field-with-copy">
          <v-autocomplete
            v-model="manifest.pattern_id"
            :disabled="!manifest.target_for_registration"
            :items="patterns"
            dense
            label="再資源化等パターン"
            hide-details="auto"
            outlined
            persistent-placeholder
            @change="patternChangeEvent"
            class="field-with-copy__control"
          >
            <template v-slot:item="scope">
              <div>
                <div class="float-left">
                  <v-chip small color="primary">{{ scope.item.type === 'methods' ? '処分場処理方法' : '処理フロー' }}</v-chip>
                </div>
                <div class="float-left ml-5">
                  <small>{{ scope.item.text }}</small>
                </div>
                <br class="clearfix" />
              </div>
            </template>
          </v-autocomplete>
          <div class="copy-actions mt-1">
            <choose-recycle-disposal-pattern-botton
              :disabled="!manifest.target_for_registration"
              :fixed-condition="patternFixedCondition"
              small-button
              button-caption="選択"
              only-flow
              @choseRecycleDisposalPatternCallback="onPatternSelected"
            />
          </div>
          <div
            v-if="!isBulk && isFirstField"
            class="copy-actions mt-1"
          >
            <v-btn
              :disabled="!manifest.target_for_registration"
              color="primary"
              small
              @mousedown.stop.prevent
              @click.stop="copyFieldButtonClickEvent('pattern_id', manifest.pattern_id)"
            >
              <v-icon>mdi-chevron-double-down</v-icon>
            </v-btn>
          </div>
        </div>
      </v-col>
    </v-row>
    <!-- /再資源化等パターン -->

  </div>
</template>

<style scoped lang="scss">
.field-with-copy {
  display: flex;
  align-items: flex-start;
}

.field-with-copy__control {
  flex: 1;
  min-width: 0;
}

.copy-actions {
  padding-top: 4px;
}
</style>
